import { ReactNode } from 'react';
import { useStorage } from '../hooks/storage/useStorage';
import { defaultSettings, isValidSettingsObject, Settings, SettingsContext } from './settings';

const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettings] = useStorage<Settings>('local', 'settings', defaultSettings, isValidSettingsObject, {});

  return <SettingsContext.Provider value={[settings, setSettings]}>{children}</SettingsContext.Provider>;
};

export default SettingsProvider;
